export const ChargeStatus = {
  Pending: "pending",
  Settled: "settled",
  Voided: "voided",
} as const;

export type ChargeStatus = (typeof ChargeStatus)[keyof typeof ChargeStatus];
